var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CButton,
    {
      staticClass: "social-auth-button",
      attrs: { disabled: _vm.disabled || _vm.loading },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _vm.loading
        ? _c("b-spinner", { attrs: { small: "" } })
        : _setup.icon
        ? _c("img", {
            staticClass: "social-auth-button-icon",
            attrs: { src: _setup.icon, alt: "social-logo" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "social-auth-button-label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }